import { Pie, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
/* eslint-disable */
import ChartJSPluginDatalabels from "chartjs-plugin-datalabels";

export default {
  extends: Pie,
  mixins: [reactiveProp],
  data() {
    return {
      options: {
        responsive: true, 
        maintainAspectRatio: false, 
        tooltips: {
          enabled: false
        },
        plugins: {
          datalabels: {
            color: 'white',
            formatter: function (value) {
              return value == 0 ? '' : value;
            },
            font: {
              weight: 'bold',
              size: 20,
            }
          }
        }
      }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};